import { createContext } from "react";

export const StepSelectOptions = createContext();
